import { Component } from '@angular/core';

@Component({
    selector: 'app-dialog-temporary-help',
    template: `<h2 mat-dialog-title>Coming Soon</h2>
    <mat-dialog-content>
      <div style="text-align:center;">
        <img src="../../../assets/img/content-coming-soon.svg" />
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button type="button" mat-raised-button [mat-dialog-close]="true">
        Cancel
      </button>
    </mat-dialog-actions> `,
    standalone: false
})
export class ComingSoonComponent { }
